import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';

import WP from 'WP';

const SmartLink = props => {
    
    const { to, target, children, className, onClick, exact, onFocus } = props;

    if(!to) return '"to" prop is required'

    const internal = to.indexOf(WP.home) !== -1 || to[0] === '/';

    // if link is internal - remove the domain
    let url = internal ? to.replace(WP.home, '') : to;

    // make sure internal links start from '/'
    if(internal && url[0] !== '/') url = '/'+url;

    // make sure english links start form /en/
    if(internal && WP.lang === 'en' && url.indexOf('/'+WP.lang+'/') === -1 )
        url = '/'+WP.lang+url;

    if (internal) {
        return (
            <Link
                className={className}
                to={url}
                target={target}
                onFocus={onFocus ? e => onFocus(e) : undefined}
                onClick={onClick ? e => onClick(e) : undefined}
            >{children}</Link>
        );
    }

    return (
        <a
            className={className}
            href={url}
            target={target}
            rel={target === '_blank' ? 'noopener noreferrer' : undefined}
            onFocus={onFocus ? e => onFocus(e) : undefined}
            onClick={onClick ? e => onClick(e) : undefined}
        >{children}</a>
    );
}

export default withRouter(SmartLink);


// WEBPACK FOOTER //
// ./src/partials/SmartLink.js